import React from 'react';
import { Bell, Inbox } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { ScrollArea } from '../ui/scroll-area';

export function NotificationPane() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="w-10 h-10 rounded-lg hover:bg-[--clinqr-bg-subtle] flex items-center justify-center transition-colors relative">
          <Bell className="w-5 h-5 text-[--clinqr-text-secondary]" strokeWidth={2} />
          <span className="absolute top-2 right-2 w-2 h-2 bg-[--clinqr-error] rounded-full"></span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 overflow-hidden bg-white">
        <div className="p-4 border-b border-[--clinqr-border] bg-white">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold text-[--clinqr-text-primary]">Notifications</h3>
            <span className="text-[10px] font-medium px-2 py-0.5 bg-[--clinqr-bg-subtle] text-[--clinqr-text-secondary] rounded-full">
              0 New
            </span>
          </div>
        </div>
        <ScrollArea className="h-[300px]">
          <div className="flex flex-col items-center justify-center h-full py-12 px-4 text-center">
            <div className="w-12 h-12 rounded-full bg-[--clinqr-bg-subtle] flex items-center justify-center mb-3">
              <Inbox className="w-6 h-6 text-[--clinqr-text-muted]" />
            </div>
            <p className="text-sm font-medium text-[--clinqr-text-primary]">No new notifications</p>
            <p className="text-xs text-[--clinqr-text-secondary] mt-1">
              We'll notify you when something important happens.
            </p>
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
}
